import React, { Component } from 'react';
import { DateTime } from 'luxon';
import { startCase } from 'lodash';
import * as moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import Button from '@material-ui/core/Button';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { withSnackbar } from 'notistack';
// import { enqueueSnackbar } from 'notistack';
// import socketIoClient from '../../socket/socketConfig';
import { CurrentPracticeConsumer } from '../../contexts/CurrentPracticeContext';
import ProviderRestrictedModal from '../ProviderAdminPatients/components/ProviderRestrictedModal';
import PatientRestrictForProvider from '../ProviderAdminPatients/components/PatientRestrictForProvider';
import CurrentUserContext from '../../contexts/CurrentUserContext';
import TabPanel from '../../components/TabPanel';
import AppointmentEditModal from '../../components/AppointmentEditModal';
import CreateAppointmentModal from './components/CreateAppointmentModal';
import TextOnlyTooltip from './components/Tooltip';
import * as adminApi from '../../services/api/admin';
import { bookAppointment,overBookedAppt } from '../../services/api';

import './style.css';

const UPCOMING_TAB = 0;
const PAST_TAB = 1;

class ProviderAdminAppointments extends Component {
  state = {
    appointments: [],
    tenancies: [],
    appointmentUnderEdit: {},
    activeProvider: {},
    currentUser: {},
    tabPosition: 0,
    isLoading: true,
    openAppointmentModal: false,
    openCreateAppointmentModal: false,
    showProviderRestrictedModal: false,
    showPatientRestrictPopUp: false,
    statuses: [],
    pageIndex: 0,
    pageLimit: 20,
    providerFamily: '',
    overBookAlert: false,
    // openDuplicateApptAlert: false,
    // closeDuplicateApptAlert: false,   

  };

  async componentDidMount() {
    const { activeProvider, currentUser } = this.context;
    const { tabPosition } = this.state;
    const fetchedStatuses = await adminApi.fetchAppointmentStatuses();
    this.setState({
      statuses: fetchedStatuses.map(status => ({
        value: status,
        label: startCase(status),
      })),
    });
    this.fetchAppointments(activeProvider, tabPosition);
    this.fetchTenancies(activeProvider.id);
    this.setCurrentUserInfo(currentUser);
  }

  fetchAppointments = async (provider, tabPosition) => {
    const { enqueueSnackbar } = this.props;
    let appointments = [];
    const { pageIndex } = this.state;
    this.setState({ isLoading: true });
    try {
      if (tabPosition === UPCOMING_TAB) {
        appointments = await adminApi.fetchAppointments({
          providerId: provider.id,
          upcoming: true,
          offset: pageIndex * 20,
        });
      } else if (tabPosition === PAST_TAB) {
        appointments = await adminApi.fetchAppointments({
          providerId: provider.id,
          past: true,
          offset: pageIndex * 20,
        });
      }
      this.setState({
        appointments: appointments,
        activeProvider: provider,
        tabPosition,
      });
    } catch (err) {
      enqueueSnackbar('Fetching appointments failed. Please try again.');
    } finally {
      this.setState({ isLoading: false });
    }
  };

  setCurrentUserInfo = currentUserInfo => {
    try {
      this.setState({ currentUser: currentUserInfo });
    } catch (error) {
      console.log(error);
    }
  };

  onPageForward = async () => {
    //this won't cover the case where the total num of consult notes % PAGE_LIMIT = 0. But it's a quick fix for now.
    const { tabPosition, activeProvider } = this.state;
    const { enqueueSnackbar } = this.props;
    if (this.state.appointments.length < this.state.pageLimit) {
      enqueueSnackbar('You are on the last page');
    } else {
      this.setState({ pageIndex: this.state.pageIndex + 1 }, () => {
        this.fetchAppointments(activeProvider, tabPosition);
      });
    }
  };

  onPageBack = async () => {
    const { tabPosition, activeProvider } = this.state;
    const { enqueueSnackbar } = this.props;
    if (this.state.pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    } else {
      this.setState({ pageIndex: this.state.pageIndex - 1 }, () => {
        this.fetchAppointments(activeProvider, tabPosition);
      });
    }
  };

  fetchTenancies = async providerId => {
    const tenancies = await adminApi.fetchTenancies(providerId);
    this.setState({ tenancies });
  };

  handleTabPositionChange = (event, newTabPosition) => {
    this.setState({ pageIndex: 0 }, () => {
      const { activeProvider } = this.state;
      this.fetchAppointments(activeProvider, newTabPosition);
    });
  };

  onProviderChange = async (providerId, practice) => {
    const { tabPosition } = this.state;
    const providers = practice.providers;
    const provider = providers.find(provider => provider.id === providerId);
    return this.fetchAppointments(provider, tabPosition);
  };

  onCreateNewAppointment = () => {
    this.setState({ openCreateAppointmentModal: true });
  };

  onEdit = appointment => {
    this.setState({
      appointmentUnderEdit: appointment,
      openAppointmentModal: true,
    });
  };

  onSave = async appointment => {
    const { enqueueSnackbar } = this.props;
    const { activeProvider, tabPosition } = this.state;

    try {
      await adminApi.updateAppointmentStatus(appointment, tabPosition);
      enqueueSnackbar('Appointment status Changed Successfully');
      this.onClose();
    } catch (err) {
      enqueueSnackbar('Error updating appointment status. Please try again.');
    } finally {
      await this.fetchAppointments(activeProvider, tabPosition);
    }
  };

  onCreate = async appointment => {
    const { enqueueSnackbar } = this.props;
    const { activeProvider, tabPosition, currentUser } = this.state;
    const restrictedPracticeName = await adminApi.fetchProviderDetails(
      appointment.providerId
    );
    this.setState({
      providerFamily: restrictedPracticeName.data.practiceName,
    });

    try {
      // Check user timezone
      const currentUserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      // Convert UTC to America/New_York time, automatically handling DST
      const estTime = DateTime.fromISO(appointment.time, { zone: "UTC" }).setZone("America/New_York");
      const apptHour = estTime.hour;
      
      if(currentUserTimezone!=='America/New_York' || (apptHour < 6 || apptHour > 22)){
        alert("⚠️ Time Zone Mismatch Detected:\n" + "Kindly switch your system time zone to \"America/New_York, EST\" to proceed further.");
        return;
      }

      //Check for existing appointments.
      const bookedAppt = await overBookedAppt({
        start: moment(appointment.time).toISOString(),
        tenancyId: appointment.tenancyId,
        providerId: appointment.providerId,
      });
      // console.log(bookedAppt, 'bookedAppt');
      const isApptOverBooked = bookedAppt.some(
        (obj) => obj.isCurrentTimeInRange === true
      );
      if (!isApptOverBooked) {
      const responseMessage = await bookAppointment({
        tenancy: {
          id: appointment.tenancyId,
        },
        appointment: {
          startTimestamp: moment(appointment.time).toISOString(),
          portalNotes: appointment.portalNotes,
          createdBy: appointment.fromProviderUserId,
          attachments: appointment.attachments,
          providerId: appointment.providerId,
        },
        patient: {
          email: appointment.patientEmail,
          insurancePlanId: appointment.patientInsurancePlanId,
          insuranceName: appointment.patientInsuranceName,
          insuranceId: appointment.patientInsuranceId,
          payerId: appointment.patientPayerId,
          groupNumber: appointment.patientGroupNumber,
          addressLine1: appointment.patientAddressLine1,
          addressLine2: appointment.patientAddressLine2,
          city: appointment.patientCity,
          state: appointment.patientState,
          zipcode: appointment.patientZipcode,
        },
      });
      if (responseMessage === 'No access to Book Appointment') {
        this.setState({ showProviderRestrictedModal: true });
      } else if (responseMessage === 'Patient No access to Book Appointment') {
        this.setState({ showPatientRestrictPopUp: true });
      }
       else if(responseMessage.msg === 'Patient already has an appointment on this day') {
        alert("This patient already has an appointment booked at Westside Family Medicine on this date.  Only one appointment per practice per day is allowed.  Please choose another day, or cancel the other appointment and then re-attempt your booking.");
        return;
        // this.setState({ openDuplicateApptAlert: true });
       }
      else {
        enqueueSnackbar('Appointment created.', {
          preventDuplicate: true,
          autoHideDuration: 3000,
        });
        this.onClose();
        return true;
        // socketIoClient.emit('message', {
        //   message: 'auto-refresh-Appointments',
        //   id: this.state.currentUser && this.state.currentUser.id,
        // });
      }
    }
    else{
      this.setState({overBookAlert: true});
      return false;
      
    }
    } catch (err) {
      enqueueSnackbar('Error creating appointment. Please try again.');
    }
    await this.fetchAppointments(activeProvider, tabPosition);
  };

  onRestrictedClose = () => {
    this.setState({
      showProviderRestrictedModal: false,
    });
  };

  onClosePatientPopUp = () => {
    this.setState({
      showPatientRestrictPopUp: false,
    });
  };

  onClose = () => {
    this.setState({
      appointmentUnderEdit: {},
      openAppointmentModal: false,
      openCreateAppointmentModal: false,
      showProviderRestrictedModal: false,
    });
  };

  closeAlert = ()=>{
    this.setState({ overBookAlert: false });
   }
    // closeDuplicateApptAlert = ()=>{
    //   this.setState({ openDuplicateApptAlert: false });
    // }
  render() {
    const {
      appointments,
      activeProvider,
      tabPosition,
      isLoading,
      appointmentUnderEdit,
      openAppointmentModal,
      openCreateAppointmentModal,
      showProviderRestrictedModal,
      showPatientRestrictPopUp,
      pageIndex,
      pageLimit,
      providerFamily,
    } = this.state;
    const { classes } = this.props;

    return (
      <CurrentPracticeConsumer>
        {({ currentPractice }) => (
          <div className={classes.root}>
            <div className={classes.main}>
              <div className="overflowHidden">
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  classes={{ container: classes.header }}
                >
                  <Grid item xs={12} md={6} className="bkedAppHead">
                    <Typography variant="h2" className={classes.headerText}>
                      Booked Appointments
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} classes={{ item: classes.actions }}>
                    <Select
                      value={activeProvider.id || ''}
                      className={classes.dropdown}
                      onChange={event =>
                        this.onProviderChange(
                          event.target.value,
                          currentPractice
                        )
                      }
                    >
                      {(currentPractice.providers || []).map(provider => {
                        return (
                          <MenuItem style={{whiteSpace:"normal"}} value={provider.id} key={provider.id}>
                            {provider.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.onCreateNewAppointment}
                      className="appointBtn"
                    >
                      Create a new appointment
                    </Button>
                  </Grid>
                </Grid>
              </div>

              <AppBar
                position="static"
                color="default"
                classes={{ root: classes.appBar }}
              >
                <Tabs
                  value={tabPosition}
                  onChange={this.handleTabPositionChange}
                >
                  <Tab label="Upcoming" />
                  <Tab label="Past" />
                </Tabs>
              </AppBar>

              <TabPanel className="overflowAuto">
                {isLoading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  <Grid style={{overflow:"scroll"}} item xs={12}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Patient</TableCell>
                          <TableCell>Date & Time</TableCell>
                          <TableCell>Location</TableCell>
                          <TableCell>Notes</TableCell>
                          <TableCell>Patient Reason</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {appointments &&
                          appointments.length > 0 &&
                          appointments.map(appointment => (
                            <TableRow key={appointment.id}>
                              <TableCell width="300">
                                {appointment.patientName} (
                                {appointment.patientAge}{' '}
                                {appointment.patientGender
                                  ? startCase(appointment.patientGender[0])
                                  : ''}
                                )
                              </TableCell>
                              <TableCell width="200">
                                {moment(appointment.time).format(
                                  'MM/DD/YYYY hh:mma'
                                )}
                              </TableCell>
                              <TableCell width="300">
                                {appointment.tenancyLocation}
                              </TableCell>
                              {appointment.portalNotes &&
                              appointment.portalNotes ? (
                                <TextOnlyTooltip
                                  title={
                                    appointment.portalNotes &&
                                    appointment.portalNotes
                                  }
                                  placement="bottom"
                                  enterTouchDelay={300}
                                  key={`tooltip-${appointment.id}`}
                                  arrow={true}
                                >
                                  <TableCell width="250">
                                    {appointment.portalNotes &&
                                      `${appointment.portalNotes.slice(
                                        0,
                                        20
                                      )}...`}
                                  </TableCell>
                                </TextOnlyTooltip>
                              ) : (
                                <TableCell width="250">
                                  {appointment.portalNotes &&
                                    `${appointment.portalNotes.slice(
                                      0,
                                      20
                                    )}...`}
                                </TableCell>
                              )}
                              {appointment.patientReason &&
                              appointment.patientReason ? (
                                <TextOnlyTooltip
                                  title={
                                    appointment.patientReason &&
                                    appointment.patientReason
                                  }
                                  placement="bottom"
                                  enterTouchDelay={300}
                                  key={`tooltip-${appointment.id}`}
                                  arrow={true}
                                >
                                  <TableCell width="250">
                                    {appointment.patientReason &&
                                      `${appointment.patientReason.slice(
                                        0,
                                        20
                                      )}...`}
                                  </TableCell>
                                </TextOnlyTooltip>
                              ) : (
                                <TableCell width="250">
                                  {appointment.patientReason &&
                                    `${appointment.patientReason.slice(
                                      0,
                                      20
                                    )}...`}
                                </TableCell>
                              )}

                              <TableCell width="200">
                                {startCase(appointment.status)}
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  onClick={() => this.onEdit(appointment)}
                                >
                                  <EditIcon />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </Grid>
                )}
                    <div className={classes.pageTurners}>
                      <IconButton disabled={pageIndex === 0}>
                        <ArrowBackIosIcon
                          style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
                          color="primary"
                          variant="contained"
                          onClick={() => this.onPageBack()}
                        />
                      </IconButton>
                      <IconButton disabled={appointments.length < pageLimit}>
                        <ArrowForwardIosIcon
                          style={{
                            opacity:
                              appointments.length < pageLimit ? '0.5' : '1.0',
                          }}
                          color="primary"
                          variant="contained"
                          onClick={() => this.onPageForward()}
                        />
                      </IconButton>
                    </div>
              </TabPanel>
            </div>

            <AppointmentEditModal
              statuses={this.state.statuses}
              appointment={appointmentUnderEdit}
              open={openAppointmentModal}
              save={this.onSave}
              onClose={this.onClose}
            />

            <CreateAppointmentModal
              onSubmit={this.onCreate}
              open={openCreateAppointmentModal}
              onClose={this.onClose}
              overBookAlert={this.state.overBookAlert}
              closeAlert={this.closeAlert}
              // openDuplicateApptAlert={this.state.openDuplicateApptAlert}
              // closeDuplicateApptAlert={this.closeDuplicateApptAlert}
            />

            <ProviderRestrictedModal
              open={showProviderRestrictedModal}
              onClose={this.onRestrictedClose}
              providerFamily={providerFamily}
            />
            <PatientRestrictForProvider
              open={showPatientRestrictPopUp}
              onClose={this.onClosePatientPopUp}
            />
          </div>
        )}
      </CurrentPracticeConsumer>
    );
  }
}

ProviderAdminAppointments.contextType = CurrentUserContext;

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    overflow: 'scroll',
    padding: '3em',
  },
  main: {
    width: '100%',
    height: '100%',
  },
  header: {
    paddingBottom: '3em',
  },
  dropdown: {
    marginRight: '1em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '19px',
    color: '#1C1C1C',
  },
  actions: {
    textAlign: 'right',
  },
  cancelled: {
    color: '#FF1644',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export default withStyles(styles)(withSnackbar(ProviderAdminAppointments));
